import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import PageContainerContext from "./PageContainerContext";

interface Props {
  name: string;
}

const PageContent = ({ name, children }: PropsWithChildren<Props>) => {
  const { selectedContentName } = useDefinedContext(PageContainerContext);

  if (name !== selectedContentName) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, py: 2.5, px: 3, overflow: "auto" }}>
      {children}
    </Box>
  );
};

export default PageContent;
